document.addEventListener('DOMContentLoaded', function () {

  function addBusinessDays(startDate, days) {
    const date = new Date(startDate);
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);

      const day = date.getDay();

      if (day !== 0 && day !== 6) {
        added++;
      }
    }

    return date;
  }

  function addCalendarDays(startDate, days) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + days);
    return date;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  }

  function formatDeliveryRange(startDate, endDate) {
    if (startDate.getTime() === endDate.getTime()) {
      return formatDate(startDate);
    }

    const sameMonth = startDate.getMonth() === endDate.getMonth();

    if (sameMonth) {
      return (
        startDate.toLocaleDateString('en-US', { month: 'short' }) +
        ' ' +
        startDate.getDate() +
        '–' +
        endDate.getDate()
      );
    }

    return formatDate(startDate) + '–' + formatDate(endDate);
  }

  function updateLuxxriShippingDates() {
    document.querySelectorAll('.luxxri-shipping-date').forEach(function (element) {

      const processingDays = parseInt(element.dataset.processingDays, 10);
      const deliveryMinDays = parseInt(element.dataset.deliveryMinDays, 10);
      const deliveryMaxDays = parseInt(element.dataset.deliveryMaxDays, 10);

      if (
        isNaN(processingDays) ||
        isNaN(deliveryMinDays) ||
        isNaN(deliveryMaxDays)
      ) return;

      const today = new Date();

      const processingType =
        element.dataset.processingType || 'business';

      const deliveryType =
        element.dataset.deliveryType || 'calendar';

      const shipDate =
        processingType === 'calendar'
          ? addCalendarDays(today, processingDays)
          : addBusinessDays(today, processingDays);

      const deliveryStartDate =
        deliveryType === 'business'
          ? addBusinessDays(shipDate, deliveryMinDays)
          : addCalendarDays(shipDate, deliveryMinDays);

      const deliveryEndDate =
        deliveryType === 'business'
          ? addBusinessDays(shipDate, deliveryMaxDays)
          : addCalendarDays(shipDate, deliveryMaxDays);

      const customOrder = element.dataset.customOrder === 'true';

      const deliveryRange = formatDeliveryRange(
        deliveryStartDate,
        deliveryEndDate
      );

      if (customOrder) {
        element.textContent =
          'Custom Order • Ships by ' +
          formatDate(shipDate) +
          ' • Delivery ' +
          deliveryRange;
      } else {
        element.textContent =
          'Ships by ' +
          formatDate(shipDate) +
          ' • Delivery ' +
          deliveryRange;
      }
    });
  }

  updateLuxxriShippingDates();

});